import React from "react";

import MobileLayout from "../../components/MobileLayout";
import { ThemeSettingsPanel } from "../../shared/components";
import {
  Main,
  SectionHeader,
  SectionHint,
  SectionTitle,
} from "../Register/styles";

const PersonalizationPage: React.FC = () => (
  <MobileLayout headerTitle="Personalização" headerType="private">
    <Main style={{ maxWidth: 600 }}>
      <SectionHeader>
        <SectionTitle>Personalização</SectionTitle>
        <SectionHint>
          Modo escuro, alto contraste e cor de destaque do app.
        </SectionHint>
      </SectionHeader>
      <ThemeSettingsPanel />
    </Main>
  </MobileLayout>
);

export default PersonalizationPage;
